var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleNotch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256C496 390.859 384.773 499.734 249.053 495.898C126.41 492.438 23.129 392.086 16.375 269.582C9.703 148.543 92.83 45.91 205.143 21.664C214.887 19.562 224 27.535 224 37.5V70.414C224 77.828 218.803 83.938 211.631 85.809C136.012 105.527 80 174.289 80 256C80 353.941 160.416 433.453 258.689 431.977C349.396 430.617 426.855 356.266 431.738 265.684C436.369 179.758 378.947 106.289 300.35 85.805C293.187 83.938 288 77.836 288 70.438V37.523C288 27.551 297.133 19.562 306.883 21.672C414.957 45.016 496 140.938 496 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNotch);
export default __webpack_public_path__ + "static/media/circle-notch.8d3286a9eae797377795fbab147211c2.svg";
export { ForwardRef as ReactComponent };